import { query, waitForAllReturnWhenError } from '@confluence/query-preloader-tools';

// These 2 queries are identical to
// ArchivedPageBannerV2ArchivedPageBannerContainerQuery and ArchivedPageBannerV2ArchivedPageBannerQuery
// in ./ArchivedPageBannerV2.tsx
// They are inlined in ArchivedPageBannerV2.tsx because of Relay
import { ArchivedPageBannerContainerQuery } from './ArchivedPageBannerContainerQuery.graphql';
import { ArchivedPageBannerQuery } from './ArchivedPageBannerQuery.graphql';

export function preloadArchivedPageBannerV2Queries(contentId: string) {
	if (!contentId) {
		return Promise.resolve();
	}

	return waitForAllReturnWhenError([
		query({
			query: ArchivedPageBannerContainerQuery,
			variables: { contentId },
		}),
		query({
			query: ArchivedPageBannerQuery,
			variables: { contentId },
		}),
	]);
}
